// Slim brand ribbon shown above the hero on the public landing page.
// Establishes the property's affiliation with World of Hyatt · Inclusive Collection.

export default function HyattCollectionRibbon() {
  return (
    <section
      data-testid="hyatt-collection-ribbon"
      aria-label="A World of Hyatt Inclusive Collection property"
      style={{
        background: 'linear-gradient(90deg, #003DA5 0%, #0046C0 50%, #003DA5 100%)',
        color: '#FFFFFF',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Subtle diagonal sheen */}
      <span
        aria-hidden
        style={{
          position: 'absolute',
          inset: 0,
          background:
            'repeating-linear-gradient(115deg, rgba(255,255,255,0.04) 0px, rgba(255,255,255,0.04) 2px, transparent 2px, transparent 14px)',
          pointerEvents: 'none',
        }}
      />
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-2.5 flex items-center justify-between relative z-10 gap-3">
        <div className="flex items-center gap-3 sm:gap-4 min-w-0">
          <img
            src="/logo-hyatt-inclusive.jpg"
            alt="World of Hyatt · Inclusive Collection"
            className="h-7 sm:h-9 object-contain rounded-sm flex-shrink-0"
            style={{
              background: '#FFFFFF',
              padding: '2px 6px',
              boxShadow: '0 1px 4px rgba(0,0,0,0.18)',
            }}
          />
          <div className="hidden sm:block min-w-0">
            <div
              className="text-[9px] sm:text-[10px] font-bold tracking-[0.18em] uppercase truncate"
              style={{ fontFamily: 'Manrope, sans-serif', color: 'rgba(255,255,255,0.75)' }}
            >
              Hyatt Inclusive Collection Property
            </div>
            <div
              className="text-xs sm:text-sm font-semibold truncate"
              style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.02em' }}
            >
              Dreams Rose Hall Resort &amp; Spa · Montego Bay, Jamaica
            </div>
          </div>
        </div>

        <a
          href="#property-details"
          data-testid="hyatt-ribbon-cta"
          className="text-[10px] sm:text-xs font-bold tracking-wide uppercase whitespace-nowrap transition-all hover:-translate-y-0.5"
          style={{
            color: '#003DA5',
            backgroundColor: '#FFFFFF',
            padding: '6px 14px',
            borderRadius: '999px',
            fontFamily: 'Manrope, sans-serif',
            boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
          }}
        >
          Property Details
        </a>
      </div>
    </section>
  );
}
